var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"text-center pa-0 ma-0 mt-1"},[_c('div',{staticClass:"body-2 font-weight-medium"},[_vm._v(" "+_vm._s(_vm._f("dateFull")(_vm.item.createdAt))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }